import { HttpInterceptorFn } from '@angular/common/http';

import { errorInterceptor } from '@nbx/core/http';

import { authInterceptor } from './auth.interceptor';
import { mockInterceptor } from './mock.interceptor';

export const HTTP_INTERCEPTORS: HttpInterceptorFn[] = [
  errorInterceptor,
  mockInterceptor,
  authInterceptor,
];
